export const AN_METHOD_GET = []
export const AN_METHOD_CALL = []
export const AN_METHOD_WATCH = []
export const AN_METHOD_REF = []

export interface $AN_G {}

export interface $AN_C {}

export interface $AN_W {}

export interface $AN_R {}

export interface $AN extends $AN_G, $AN_C, $AN_W, $AN_R {}
